import { Component, computed, inject, input, resource, signal } from '@angular/core';
import { Button, Skeleton, Badge } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { Api } from '../../../../core/clients/omni-core/api';
import {
  listSupplierContracts,
  ListSupplierContracts$Params,
} from '../../../../core/clients/omni-core/functions';
import { ErrorComponent } from '../../../../shared/components/error-component/error-component';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import { OrganizationsStore } from '../../../organizations/store/organizations.store';
import { DashboardListCardSkeleton } from '../dashboard-list-card-skeleton/dashboard-list-card-skeleton';

@Component({
  selector: 'app-dashboard-supplier-contracts-card',
  imports: [
    Button,
    NgIcon,
    ErrorComponent,
    RouterLink,
    Skeleton,
    NgClass,
    Badge,
    TranslocoPipe,
    DashboardListCardSkeleton,
  ],
  templateUrl: './dashboard-supplier-contracts-card.html',
})
export class DashboardSupplierContractsCard {
  private organizationsStore = inject(OrganizationsStore);
  private api = inject(Api);

  organizationId = input.required<string>();

  protected limit = signal(2);

  protected yearInSupply = signal(new Date().getFullYear());

  private resource = resource({
    params: (): ListSupplierContracts$Params => ({
      id: this.organizationId(),
      excludeUnfinishedParseRequests: true,
      limit: this.limit(),
      orderBy: 'latestContractCheckAlertCount',
      orderDirection: 'desc',
      yearInSupply: this.yearInSupply(),
    }),
    loader: ({ params }) => this.api.invoke(listSupplierContracts, params),
  });

  protected isLoading = computed(() => this.resource.isLoading());
  protected error = computed(() => this.resource.error());
  protected totalCountCurrentYear = computed(() =>
    this.resource.hasValue() ? this.resource.value().total : 0,
  );
  protected supplierContracts = computed(() =>
    this.resource.hasValue() ? this.resource.value().items : [],
  );
  private totalCount = computed(
    () =>
      this.organizationsStore.entities()[this.organizationId()]?.childStats?.data
        ?.totalSupplierContracts ?? null,
  );
  protected hasContractsInOtherYears = computed(() => {
    const totalCount = this.totalCount();
    const totalCountCurrentYear = this.totalCountCurrentYear();
    return totalCount !== null && totalCount > totalCountCurrentYear;
  });

  protected onClickReload() {
    this.resource.reload();
  }
}
